/** @format */

import {Trans} from 'react-i18next';

import {AI_MONITORING_BANNER_STORAGE_KEY} from './constants';
import {
  ActionButton,
  CardsRow,
  CounterIcon,
  FallbackBlock,
  FallbackEmphasis,
  FallbackText,
  FallbackTextColumn,
  FeatureCard,
  HeaderTitle,
  MovingIcon,
  PlansCard,
  PlansContent,
  PlansLine,
  PlansTitle,
  Step,
  StepsList,
  StepText,
  StyledDialog,
  StyledDialogContent,
  Subtitle,
  TabActive,
  TabInactive,
  TabsRow,
} from './styles';

interface AiMonitoringBannerDialogProps {
  open: boolean;
  onClose: () => void;
}

const AiMonitoringBannerDialog = ({open, onClose}: AiMonitoringBannerDialogProps) => {
  const handleClose = () => {
    localStorage.setItem(AI_MONITORING_BANNER_STORAGE_KEY, 'true');
    onClose();
  };

  return (
    <StyledDialog open={open} onClose={handleClose} maxWidth={false}>
      <StyledDialogContent>
        <HeaderTitle>
          <Trans>Обновление ИИ-модуля</Trans>
        </HeaderTitle>
        <Subtitle>
          <Trans>
            Теперь вместо ручного запуска исследований у вас есть возможность настроить
            автоматический ежемесячный мониторинг рекламных кампаний
          </Trans>
        </Subtitle>

        <CardsRow>
          <FeatureCard>
            <TabsRow>
              <TabActive>
                <Trans>Ежемесячный мониторинг</Trans>
              </TabActive>
              <TabInactive>
                <Trans>ИИ-исследование</Trans>
              </TabInactive>
            </TabsRow>
            <StepsList>
              <Step>
                <CounterIcon className='material-symbols-outlined'>counter_1</CounterIcon>
                <StepText>
                  <Trans>Настраиваете параметры один раз</Trans>
                </StepText>
              </Step>
              <Step>
                <CounterIcon className='material-symbols-outlined'>counter_2</CounterIcon>
                <StepText>
                  <Trans>Система сама анализирует кампании первого числа каждого месяца</Trans>
                </StepText>
              </Step>
              <Step>
                <CounterIcon className='material-symbols-outlined'>counter_3</CounterIcon>
                <StepText>
                  <Trans>Получаете готовые отчеты без дополнительных действий</Trans>
                </StepText>
              </Step>
            </StepsList>
          </FeatureCard>

          <FeatureCard>
            <TabsRow>
              <TabInactive>
                <Trans>Ежемесячный мониторинг</Trans>
              </TabInactive>
              <TabActive>
                <Trans>ИИ-исследование</Trans>
              </TabActive>
            </TabsRow>
            <FallbackBlock>
              <CounterIcon className='material-symbols-outlined'>emoji_objects</CounterIcon>
              <FallbackTextColumn>
                <FallbackText>
                  <Trans>
                    Классический инструмент разового анализа по‑прежнему доступен во вкладке
                  </Trans>
                </FallbackText>
                <FallbackEmphasis>
                  <Trans>«ИИ‑исследование»</Trans>
                </FallbackEmphasis>
              </FallbackTextColumn>
            </FallbackBlock>
          </FeatureCard>
        </CardsRow>

        <PlansCard>
          <MovingIcon className='material-symbols-outlined'>moving</MovingIcon>
          <PlansContent>
            <PlansTitle>
              <Trans>Большие планы</Trans>
            </PlansTitle>
            <PlansLine>
              <Trans>
                У нас запланировано много улучшений для работы с гипотезами и ИИ-модулем
              </Trans>
            </PlansLine>
            <PlansLine>
              <Trans>Ожидайте больших обновлений АдСенсора в ближайшее время 🔥</Trans>
            </PlansLine>
          </PlansContent>
        </PlansCard>

        <ActionButton
          color='primary'
          disableElevation
          size='large'
          variant='contained'
          onClick={handleClose}
        >
          🎉 <Trans>Хорошо</Trans>
        </ActionButton>
      </StyledDialogContent>
    </StyledDialog>
  );
};

export default AiMonitoringBannerDialog;
